
import type { LtlRpp } from '@/core/types/rpp.types'
import { defineComponent, PropType, reactive } from 'vue'

import Cheap from '@/common/components/UI/Cheap/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Checkbox from '@/common/components/UI/Checkbox/index.vue'

import { rpp } from '@/core/realisations/rpp.realisation'
import tmsAPI from '@/new-services/tms.service'

import { useFile } from '@/common/composable/useFile'
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        Cheap,
        TheButton,
        Checkbox,
    },
    props: {
        item: {
            type: Object as PropType<LtlRpp>,
            required: true,
        },
        isSelected: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['select', 'unselect', 'update', 'submit'],
    setup(props, { emit }) {
        const state = reactive({
            is_loading: false,
            is_trip_print_loading: false,
        })

        const onUpdate = () => {
            emit('update', props.item.id)
        }

        const onSubmit = () => {
            emit('submit', props.item.id, props.item.tripId)
        }

        const { saveFile } = useFile()
        const notifications = useNotifications()

        const printRpp = async () => {
            try {
                state.is_loading = true

                const response = await rpp.exportLtlByIdExcel(props.item.id)
                saveFile(response, `LTL РПП (ID_${props.item.id}) распечатка.xlsx`)
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: `Произошла ошибка при скачивании`,
                })
            } finally {
                state.is_loading = false
            }
        }

        const printTrip = async () => {
            if (state.is_trip_print_loading) return

            try {
                state.is_trip_print_loading = true

                const response = await tmsAPI.printTrip(props.item.tripId)
                saveFile(response.data, `Рейс (${props.item.tripNumber}).xlsx`)
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: `Произошла ошибка при скачивании печати рейса`,
                })
            } finally {
                state.is_trip_print_loading = false
            }
        }

        const onSelect = () => {
            if (props.isSelected) {
                emit('unselect', props.item)
                return
            }

            emit('select', props.item)
        }

        const formatDate = (dateStr: string | null) => {
            if (!dateStr) return '-'

            const dateFirst = dateStr.split(' ')[0]
            return dateFirst.split('-').reverse().join('.')
        }

        return {
            state,
            onUpdate,
            onSubmit,
            onSelect,
            printRpp,
            printTrip,
            formatDate,
        }
    },
})
